import React from 'react';
import request from '../../request';
import Input from '../shared/labelInput';
import Checkbox from '../shared/checkbox';

export default class Settings extends React.Component {
  constructor() {
    super();
    this.state = {
      user: JSON.parse(localStorage.getItem('current-user') || '{}'),
      loading: true,
    };
  }

  async componentDidMount() {
    try {
      let { user } = await request({ url: `settings/users/current` });
      localStorage.setItem('current-user', JSON.stringify(user));
      this.setState({ user, loading: false });
    } catch (e) {
      this.setState({ error: e.message || e, loading: false });
    }
  }

  async save() {
    try {
      this.setState({ loading: true });
      let user = await request({
        url: `settings/users/current`,
        method: 'PATCH',
        body: this.state.user,
      });

      this.setState({
        user: {
          ...user,
          password: null,
          current_password: null,
          password_confirm: null,
        },
        loading: false,
        error: null,
      });
    } catch (e) {
      this.setState({
        loading: false,
        error: e.message || e,
        user: {
          ...this.state.user,
          password: null,
          password_confirm: null,
          current_password: null,
        },
      });
    }
  }

  render() {
    let { user, loading, error } = this.state;

    return (
      <div id="dashboard" style={{ opacity: loading ? 0.8 : 1 }}>
        {error ? <p className="error">{error}</p> : null}
        <Input
          name="first_name"
          label="First Name"
          value={user.first_name || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <Input
          name="last_name"
          label="Last Name"
          value={user.last_name || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <Input
          id="email_field"
          name="email"
          label="Email"
          value={user.email || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <Checkbox
          label="Notifications"
          description="Receive system notifications by email"
          value={user.can_email}
          onChange={value =>
            this.setState({ user: { ...user, can_email: value } })}
        />

        <h5 className="heading dots">Change Password</h5>

        <Input
          name="password"
          type="password"
          label="New Password"
          value={user.password || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <Input
          name="password_confirm"
          type="password"
          label="Verify Password"
          value={user.password_confirm || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <h5 className="heading dots">Current Password</h5>

        <Input
          name="current_password"
          label="Current Password"
          type="password"
          value={user.current_password || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <div className="options">
          <button
            className="control_button"
            id="save"
            onClick={() => this.save()}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/my-account.js